import React, { useState, useEffect, useCallback } from 'react';
import { Input, message, Button } from 'antd';
import { WarningLabel } from '../../components/Modals/styles';
import {
  UserDetailHeadingCover,
  LineSeparator,
  InputContainer,
  InputLabel,
  ConfigKeys,
} from './styles';
import Loader from '../../components/Loader';
import { LoginContainer } from '../../components/Modals/styles';
import { useTranslation } from 'react-i18next';
import {
  getGoogleConfig,
  addGoogleConfig,
  updateGoogleConfig,
} from '../../utils/services/googleAPI';
import { MANAGE_TEXT_TO_SPEECH_CONFIGURATION } from './TranslationValues';

const NAMESPACES = ['MANAGE_TEXT_TO_SPEECH_CONFIGURATION'];

const TextToSpeechConfig = props => {
  const { onCancel } = props;
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation(NAMESPACES);
  const [editable, setEditable] = useState(false);
  const [configDetails, setConfigDetails] = useState({});
  const [warningText, setWarningText] = useState({});
  let configKeys = [
    {
      key: 'type',
      name: t(
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_TYPE_LABEL.key,
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_TYPE_LABEL.value,
      ),
    },
    {
      key: 'project_id',
      name: t(
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_PROJECT_ID_LABEL.key,
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_PROJECT_ID_LABEL.value,
      ),
    },
    {
      key: 'private_key_id',
      name: t(
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_PRIVATE_KEY_ID_LABEL.key,
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_PRIVATE_KEY_ID_LABEL.value,
      ),
    },
    {
      key: 'private_key',
      name: t(
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_PRIVATE_KEY_LABEL.key,
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_PRIVATE_KEY_LABEL.value,
      ),
    },
    {
      key: 'client_email',
      name: t(
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_CLIENT_EMAIL_LABEL.key,
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_CLIENT_EMAIL_LABEL.value,
      ),
    },
    {
      key: 'client_id',
      name: t(
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_CLIENT_ID_LABEL.key,
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_CLIENT_ID_LABEL.value,
      ),
    },
    {
      key: 'auth_uri',
      name: t(
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_AUTH_URI_LABEL.key,
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_AUTH_URI_LABEL.value,
      ),
    },
    {
      key: 'token_uri',
      name: t(
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_TOKEN_URI_LABEL.key,
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_TOKEN_URI_LABEL.value,
      ),
    },
    {
      key: 'auth_provider_x509_cert_url',
      name: t(
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_AUTH_PROVIDER_CERT_URL_LABEL.key,
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_AUTH_PROVIDER_CERT_URL_LABEL.value,
      ),
    },
    {
      key: 'client_x509_cert_url',
      name: t(
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_CLIENT_CERT_URL_LABEL.key,
        MANAGE_TEXT_TO_SPEECH_CONFIGURATION.CONFIG_CLIENT_CERT_URL_LABEL.value,
      ),
    },
  ];

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = useCallback(async () => {
    const response = await getGoogleConfig();
    if (response?.data && response?.data.length > 0) {
      let credentials = response.data[0].credentials;
      let credentialJSON = {
        id: response.data[0].id,
        ...credentials,
      };
      // let credentials = response.data[0].credentials.split(',');
      // for (let i = 0; i < credentials.length; i++) {
      //   configKeys.map(configKey => {
      //     if (credentials[i]?.includes(configKey.key)) {
      //       let value = credentials[i].replace(`${configKey.key}=`, '');
      //       if (i === 0) {
      //         credentialJSON[configKey.key] = value.trim().substring(1);
      //       } else if (i === credentials.length - 1) {
      //         credentialJSON[configKey.key] = value.trim().substring(1, credentials[i].length - 1);
      //       } else {
      //         credentialJSON[configKey.key] = value.trim();
      //       }
      //     }
      //   });
      // }
      setConfigDetails(credentialJSON);
    }
    setLoading(false);
  }, []);

  const handleChange = e => {
    const { value, name } = e.target;
    setConfigDetails({ ...configDetails, [name]: value });
    if (value) {
      delete warningText[name];
      setWarningText({
        ...warningText,
      });
    } else {
      setWarningText({
        ...warningText,
        [name]: t(MANAGE_TEXT_TO_SPEECH_CONFIGURATION.INVALID_INPUT_WARNING_MESSAGE.key, {
          name: name,
        }),
      });
    }
  };

  const onSave = useCallback(async () => {
    setLoading(true);
    let response;
    if (configDetails?.id) {
      response = await updateGoogleConfig(configDetails);
    } else {
      response = await addGoogleConfig(configDetails);
    }
    if (response) {
      setLoading(false);
      if (response.statusCode === 9999) {
        message.error(
          t(
            MANAGE_TEXT_TO_SPEECH_CONFIGURATION.UNABLE_TO_ADD_OR_UPDATE_ERROR_MESSAGE.key,
            MANAGE_TEXT_TO_SPEECH_CONFIGURATION.UNABLE_TO_ADD_OR_UPDATE_ERROR_MESSAGE.value,
          ),
        );
      } else if (response?.errors?.length === 0) {
        message.success(
          t(
            MANAGE_TEXT_TO_SPEECH_CONFIGURATION.ADDED_CONFIGURATION_SUCCESS_MESSAGE.key,
            MANAGE_TEXT_TO_SPEECH_CONFIGURATION.ADDED_CONFIGURATION_SUCCESS_MESSAGE.value,
          ),
        );
        onCancel();
      }
    }
  }, [configDetails]);

  const validateDetails = async () => {
    if (Object.keys(warningText).length === 0) {
      onSave();
    }
  };

  return (
    <React.Fragment>
      <UserDetailHeadingCover textToSpeech>
        <div>
          <h5>
            {t(
              MANAGE_TEXT_TO_SPEECH_CONFIGURATION.MANAGE_TEXT_TO_SPEECH_CONFIGURATION_TITLE.key,
              MANAGE_TEXT_TO_SPEECH_CONFIGURATION.MANAGE_TEXT_TO_SPEECH_CONFIGURATION_TITLE.value,
            )}
          </h5>
        </div>
        {editable ? (
          <Button
            type="primary"
            className="add_user_btn"
            onClick={() => {
              validateDetails();
              Object.keys(warningText).length === 0 && setEditable(false);
            }}
          >
            {configDetails?.id
              ? t(
                  MANAGE_TEXT_TO_SPEECH_CONFIGURATION.UPDATE_CONFIGURATION_BUTTON.key,
                  MANAGE_TEXT_TO_SPEECH_CONFIGURATION.UPDATE_CONFIGURATION_BUTTON.value,
                )
              : t(
                  MANAGE_TEXT_TO_SPEECH_CONFIGURATION.ADD_CONFIGURATION_BUTTON.key,
                  MANAGE_TEXT_TO_SPEECH_CONFIGURATION.ADD_CONFIGURATION_BUTTON.value,
                )}
          </Button>
        ) : (
          <Button
            type="primary"
            className="add_user_btn"
            onClick={() => {
              setEditable(true);
            }}
          >
            {t(
              MANAGE_TEXT_TO_SPEECH_CONFIGURATION.EDIT_CONFIGURATION_BUTTON.key,
              MANAGE_TEXT_TO_SPEECH_CONFIGURATION.EDIT_CONFIGURATION_BUTTON.value,
            )}
          </Button>
        )}
      </UserDetailHeadingCover>
      <LineSeparator />
      {loading ? (
        <LoginContainer>
          <Loader />
        </LoginContainer>
      ) : (
        <>
          <ConfigKeys>
            {configKeys.map(eachKey => {
              return (
                <InputContainer className="full-width" TextToSpeech={1}>
                  <InputLabel googleConfig>{eachKey.name}</InputLabel>
                  <Input
                    size="large"
                    placeholder={eachKey.name}
                    name={eachKey.key}
                    onChange={handleChange}
                    autoComplete={'off'}
                    readOnly={!editable}
                    value={configDetails[eachKey.key]}
                  />
                  <WarningLabel>{warningText[eachKey.key]}</WarningLabel>
                </InputContainer>
              );
            })}
          </ConfigKeys>
        </>
      )}
    </React.Fragment>
  );
};

export default TextToSpeechConfig;
